import React, { useRef } from 'react'
import { useTheme, useMediaQuery } from '@mui/material'
import Drawer from '@mui/material/Drawer'
import PropTypes from 'prop-types'
import useClickOutside from '../../../utils/hooks'
import OpsotButton from '../OpsotButton/index'
import OpsotTypography from '../OpsotTypography/index'

const OpsotDrawer = ({
	title,
	body,
	isOpen,
	onDismiss,
	dismissText = 'Dismiss'
}) => {
	const theme = useTheme()
	const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
	const ref = useRef(null)

	useClickOutside(ref, onDismiss, true)

	return (
		<Drawer
			ref={ref}
			anchor="right"
			open={isOpen}
			onClose={onDismiss}
			transitionDuration={0}
			slotProps={{
				backdrop: {
					sx: {
						backgroundColor: theme.palette.primary.main,
						opacity: '0.95!important',
						left: { xs: '13%', sm: '20%', md: '44%' }
					}
				}
			}}
			PaperProps={{
				sx: {
					position: 'absolute',
					top: '50%',
					transform: 'translateY(-50%)!important',
					left: { xs: '13%', sm: '20%', md: '44%' },
					marginInline: { xs: '1rem', sm: '7.5rem' },
					height: 'auto',
					padding: { xs: '2rem', md: '3rem' },
					overflowY: 'auto',
					overflowX: 'hidden',
					maxHeight: '95vh'
				}
			}}
		>
			<OpsotTypography
				variant={isSmallScreen ? 'responsiveH3' : 'desktopH3'}
				content={title}
				sx={{ marginBottom: '1rem' }}
			/>
			<OpsotTypography
				component="div"
				variant="bodySmall"
				content={body}
				sx={{ marginBottom: { xs: '2rem', md: '4rem' } }}
			/>
			<OpsotButton
				sx={{
					marginRight: 'auto',
					justifyContent: 'flex-start',
					paddingLeft: 0
				}}
				text={dismissText}
				align="left"
				position="left"
				onClick={onDismiss}
				variant="text"
			/>
		</Drawer>
	)
}

export default OpsotDrawer

OpsotDrawer.propTypes = {
	title: PropTypes.string.isRequired,
	body: PropTypes.node.isRequired,
	isOpen: PropTypes.bool.isRequired,
	onDismiss: PropTypes.func,
	dismissText: PropTypes.string
}
